import { logEventSafe } from '@/plugins/firebase'
import { showToast } from '@/utils/toast'

class SendBurialPoint {
  private noReplyTrackingTimerId40s: ReturnType<typeof setTimeout> | null = null
  private noReplyTrackingTimerId30s: ReturnType<typeof setTimeout> | null = null
  private noReplyTrackingTimerId20s: ReturnType<typeof setTimeout> | null = null
  private noReplyTrackingTimerId15s: ReturnType<typeof setTimeout> | null = null
  private noReplyTrackingTimerId10s: ReturnType<typeof setTimeout> | null = null

  // 清除40秒无回复埋点定时器
  clearNoReplyTrackingTimer40s() {
    if (this.noReplyTrackingTimerId40s) {
      clearTimeout(this.noReplyTrackingTimerId40s)
      this.noReplyTrackingTimerId40s = null
    }
  }
  // 启动40秒无回复埋点定时器
  startNoReplyTrackingTimer40s() {
    this.clearNoReplyTrackingTimer40s()
    this.noReplyTrackingTimerId40s = setTimeout(() => {
     
      if (localStorage.getItem('modelIndex') === '3') {
        logEventSafe('ai_no_reply_balance_40s')
        console.log('40秒无回复，触发埋点—balance')
      } else {
        logEventSafe('ai_no_reply_other_40s')
        console.log('40秒无回复，触发埋点—其他模型')
      }
    }, 40000)
  }
  // 清除30秒无回复埋点定时器
  clearNoReplyTrackingTimer30s() {
    if (this.noReplyTrackingTimerId30s) {
      clearTimeout(this.noReplyTrackingTimerId30s)
      this.noReplyTrackingTimerId30s = null
    }
  }
  // 启动30秒无回复埋点定时器
  startNoReplyTrackingTimer30s() {
    this.clearNoReplyTrackingTimer30s()
    this.noReplyTrackingTimerId30s = setTimeout(() => {
      if (localStorage.getItem('modelIndex') === '3') {
        logEventSafe('ai_no_reply_balance_30s')
        console.log('30秒无回复，触发埋点—余额模型')
      } else {
        console.log('30秒无回复，触发埋点—其他模型')
        logEventSafe('ai_no_reply_other_30s')
        showToast('The response is a bit slow now. Please switch models or check your network')
      }
    }, 30000)
  }

  // 清除20秒无回复埋点定时器
  clearNoReplyTrackingTimer20s() {
    if (this.noReplyTrackingTimerId20s) {
      clearTimeout(this.noReplyTrackingTimerId20s)
      this.noReplyTrackingTimerId20s = null
    }
  }
  // 启动20秒无回复埋点定时器
  startNoReplyTrackingTimer20s() {
    this.clearNoReplyTrackingTimer20s()
    this.noReplyTrackingTimerId20s = setTimeout(() => {
      if (localStorage.getItem('modelIndex') === '3') {
        logEventSafe('ai_no_reply_balance_20s')
        console.log('20秒无回复，触发埋点—余额模型')
      } else {
        console.log('20秒无回复，触发埋点—其他模型')
        logEventSafe('ai_no_reply_other_20s')
      }
    }, 20000)
  }
  // 清除20秒无回复埋点定时器
  clearNoReplyTrackingTimer15s() {
    if (this.noReplyTrackingTimerId15s) {
      clearTimeout(this.noReplyTrackingTimerId15s)
      this.noReplyTrackingTimerId15s = null
    }
  }
  // 启动20秒无回复埋点定时器
  startNoReplyTrackingTimer15s() {
    this.clearNoReplyTrackingTimer15s()
    this.noReplyTrackingTimerId15s = setTimeout(() => {
      if (localStorage.getItem('modelIndex') === '3') {
        logEventSafe('ai_no_reply_balance_15s')
        console.log('15秒无回复，触发埋点—余额模型')
      } else {
        console.log('15秒无回复，触发埋点—其他模型')
        logEventSafe('ai_no_reply_other_15s')
      }
    }, 15000)
  }
  // 清除10秒无回复埋点定时器
  clearNoReplyTrackingTimer10s() {
    if (this.noReplyTrackingTimerId10s) {
      clearTimeout(this.noReplyTrackingTimerId10s)
      this.noReplyTrackingTimerId10s = null
    }
  }
  // 启动10秒无回复埋点定时器
  startNoReplyTrackingTimer10s() {
    this.clearNoReplyTrackingTimer10s()
    this.noReplyTrackingTimerId10s = setTimeout(() => {
      if (localStorage.getItem('modelIndex') === '3') {
        logEventSafe('ai_no_reply_balance_10s')
        console.log('10秒无回复，触发埋点—余额模型')
      } else {
        console.log('10秒无回复，触发埋点—其他模型')
        logEventSafe('ai_no_reply_other_10s')
      }
    }, 10000)
  }
  // 长时间回复拉取数据失败
  longReplyFetchFailed() {
    logEventSafe('ai_long_reply_fetch_failed')
  }
  // 长时间回复拉取数据成功
  longReplyFetchSuccess() {
    if (localStorage.getItem('modelIndex') === '3') {
      logEventSafe('ai_long_reply_fetch_success_balance')
    } else {
      logEventSafe('ai_long_reply_fetch_success_other')
    }
    console.log('长时间回复拉取数据成功')
  }
  //发送消息失败
  sendMessageFailed() {
    if (localStorage.getItem('modelIndex') === '3') {
      logEventSafe('ai_send_message_failed_balance')
    } else {
      logEventSafe('ai_send_message_failed_other')
    }
  }
  // 网络连接不稳定
  networkUnstable() {
    logEventSafe('ai_reply_received_network')
    console.log('网络连接不稳定')
  }
  // 接口失败
  interfaceFailed() {
    logEventSafe('ai_interface_failed')
    console.log('接口失败')
  }
  // 拉取超过60秒都没有消息
  noMessagePulled() {
    logEventSafe('ai_no_message_pulled')
    console.log('拉取超过60秒都没有消息')
  }
  // 清除所有无回复埋点定时器
  clearNoReplyTrackingTimer() {
    this.clearNoReplyTrackingTimer40s()
    this.clearNoReplyTrackingTimer30s()
    this.clearNoReplyTrackingTimer20s()
    this.clearNoReplyTrackingTimer15s()
    this.clearNoReplyTrackingTimer10s()
  }
}

export default SendBurialPoint
